const combineHOCs =
  (...hocs) =>
  (Component) => {
    let FinalComponent = Component;
    for (let i = 0; i < hocs.length; i++) {
      const hoc = hocs[hocs.length - 1 - i];

      FinalComponent = hoc(FinalComponent);
    }

    return FinalComponent;
  };

export default combineHOCs;
